import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getSetCookie from '../../../cookie';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import { askUserLogin, changeLogo } from '../../../actionCreators/common';
import { getReturnOrderConfig } from '../../../actionCreators/myAccount';
import './MyAccount.scss';
import MyDashboard from '../../components/MyAccount/MyDashboard/MyDashboard';
import DittoProfile from '../../components/Common/DittoProfile';
import MyAccountSavedAddress from './MyAccountSavedAddress';
import { Switch, Route } from 'react-router-dom';
import ReturnReasonNew from './OrderReturnNew/ReturnReasonNew';
import ReturnDetails from './OrderReturnNew/ReturnDetails';
import ReturnPayment from './OrderReturnNew/ReturnPayment';
// import CustomerEdit from './CustomerEdit';
// import { Switch, Route } from 'react-router-dom';
import Sidebar from '../../components/MyAccount/Sidebar/Sidebar';
import CustomerEdit from '../../components/MyAccount/CustomerEdit';
import CheckVoucher from '../../components/MyAccount/CheckVoucher';
import BlankLoader from '../../components/Common/BlankLoader';
import Prescriptions from '../../components/MyAccount/Prescriptions';
import SavedCards from '../../components/MyAccount/SavedCards';
import EditNeft from '../../components/MyAccount/EditNeft';
import StoreCredit from '../../components/MyAccount/StoreCredit';
import ReturnLabel from './OrderReturnNew/ReturnLabel';
import ManageNotification from '../../components/ManageNotification/Managenotification';
import CygnusProfile from '../../components/Common/CygnusProfile';

const hooks = {
  defer: ({ history, location, store: { dispatch, getState } }) => {
    if (!getSetCookie.getCookie('isLogined') || getSetCookie.getCookie('isLogined') !== '1') {
      window.prevUrl = location.pathname;
      history.push('/?type=login');
    }
    const { returnConfig } = getState().myAccount;
    if (!returnConfig) dispatch(getReturnOrderConfig());
  },
};

class MyAccount extends Component {
  static propTypes = {
    loginStatus: PropTypes.bool,
    shouldAskUserLogin: PropTypes.bool,
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    getSetCookie.deleteCookie('isReturnExOld');
    const { changeLogo, askUserLogin } = this.props;
    changeLogo('lenskart');
    if (getSetCookie.getCookie('isLogined') !== '1') {
      askUserLogin(true);
    }
  }

  componentDidUpdate(prevProps) {
    const { loginStatus, askUserLogin, userInfo } = this.props;

    if (prevProps.loginStatus !== loginStatus && loginStatus) {
      askUserLogin(false);
      if (window.prevUrl) {
        window.prevUrl = '';
      }
    }
    if (prevProps.loginStatus !== loginStatus && !loginStatus) {
      window.location.href = '/';
    }
    // To redirect to homepage if not logged in(upon deletion of clientv1 cookie)
    if (userInfo?.result?.login === false) {
      window.location.href = '/';
    }
  }
  render() {
    const {
      loginStatus,
      exchangeFlowSet,
      match,
      redisCommonData,
      dataLocale,
      dataLocale: { MY_ACCOUNT },
      localeInfo,
    } = this.props;
    const showSavedCards = redisCommonData && redisCommonData.USER_SAVED_CARD === 'ON';
    const isNavActive =
      (match.url && match.url === '/customer/account/') ||
      match.url?.indexOf('/customer/account/order-detail/') === 0;
    return (
      <div className="no-padding my-account-wrapper">
        <Helmet title={MY_ACCOUNT} />
        {!loginStatus && <BlankLoader />}
        {/* navigation */}
        {!exchangeFlowSet && loginStatus && (
          <div className="col-sm-3 col-md-3">
            <Sidebar
              dataLocale={dataLocale}
              isNavActive={isNavActive}
              localeInfo={localeInfo}
              redisCommonData={redisCommonData}
              showSavedCards={showSavedCards}
            />
          </div>
        )}
        {/* right side content section */}
        {/* note: ask devops for redirect customer/account#/ to customer/account/ */}
        {loginStatus && (
          <div
            className={`col-sm-9 ${
              exchangeFlowSet ? 'col-md-12' : 'col-md-9'
            } no-padding margin-b10`}
          >
            <Switch>
              <Route exact component={MyDashboard} path="/customer/account/" />
              <Route component={MyAccountSavedAddress} path="/customer/(address|new|edit)/" />
              <Route exact component={MyDashboard} path="/customer/account/order-detail/:id" />
              <Route
                exact
                component={ReturnReasonNew}
                path="/customer/my/order/return/:id/:itemId"
              />
              <Route
                exact
                component={ReturnLabel}
                path="/customer/my/order/return-label/:returnId"
              />
              <Route
                exact
                component={ReturnDetails}
                path="/customer/my/order/return/confirm-details/:orderId/:itemId"
              />
              <Route
                exact
                component={ReturnPayment}
                path="/customer/my/order/return/payment-details/:orderId/:itemId"
              />
              <Route component={CustomerEdit} path="/customer/account/edit/" />
              <Route component={Prescriptions} path="/customer/prescriptions/" />
              <Route component={CheckVoucher} path="/customer/giftvoucher/balance-check/" />
              <Route component={EditNeft} path="/customer/account/editneft*" />
              <Route component={StoreCredit} path="/customer/account/storecredit/" />
              {!redisCommonData?.ENABLE_CYGNUS && (
                <Route
                  path="/customer/ditto-profile"
                  render={props => <DittoProfile page="myAccount" {...props} />}
                />
              )}
              {redisCommonData?.ENABLE_CYGNUS && (
                <Route
                  path="/customer/3D-profile"
                  render={props => <CygnusProfile page="myAccount" {...props} />}
                />
              )}
              <Route component={SavedCards} path="/customer/saved-cards/" />
              <Route component={ManageNotification} path="/customer/manage-notification" />
            </Switch>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  location: state.router.location,
  redisCommonData: state.common.redisCommonData,
  loginStatus: state.common.login,
  breadcrumb: state.category.breadcrumb,
  returnConfig: state.myAccount.returnConfig,
  shouldAskUserLogin: state.common.askUserLogin,
  dataLocale: state.locale,
  exchangeFlowSet: state.myAccount.exchangeFlowSet,
  localeInfo: state.common.localeInfo,
  userInfo: state.common.userInfo,
});
function mapDispatchToProps(dispatch) {
  return {
    askUserLogin: value => dispatch(askUserLogin(value)),
    changeLogo: value => dispatch(changeLogo(value)),
  };
}
export default provideHooks(hooks)(connect(mapStateToProps, mapDispatchToProps)(MyAccount));
